import { Moment } from 'moment';
import { localMoment } from 'util/Time';
import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { FormGroup } from 'reactstrap';
import { InputProps, ValidationMessages } from '.';
import FieldLabel from './FieldLabel';
import DateTimePicker from './helper/DateTimePicker';
import { SingleDatePickerShape } from 'react-dates';

/**
 * Component used to handle dates and times within forms.
 *
 * @class DatePicker
 * @extends {(React.Component<FieldRenderProps & InputProps>)}
 */
class DateTime extends React.Component<
	FieldRenderProps<any, HTMLInputElement> &
		InputProps & { showAllMinutes?: boolean; singleDatePickerShape?: SingleDatePickerShape }
> {
	private initialValue: Moment | null;

	constructor(props) {
		super(props);

		// the field value is a string, but the DateTimePicker component expects the initial
		// date time as a moment object, so create one
		this.initialValue = this.props.input.value ? localMoment(this.props.input.value) : null;
	}

	private onDateTimeChange = (date: Moment) => {
		// a new date/time has been picked, update the field value with the new date
		this.props.input.onChange(date);
	};

	public render() {
		return (
			<FormGroup className={this.props.meta.dirty ? 'form-group--dirty' : ''}>
				<FieldLabel {...this.props} />

				<DateTimePicker
					dateTime={this.initialValue}
					disabled={this.props.disabled}
					onDateTimeChange={this.onDateTimeChange}
					name={this.props.input.name}
					showAllMinutes={this.props.showAllMinutes}
					singleDatePickerShape={this.props.singleDatePickerShape}
				/>

				<ValidationMessages meta={this.props.meta} id={this.props.input.name} />
			</FormGroup>
		);
	}
}

export default DateTime;
